import {lazy} from 'react';

export const Calendar = lazy(() => import('./calendar'));

export const Events = lazy(() => import('./eventlist'));

export const AddEvent = lazy(() => import('./addevent'));
